import IntlService from 'ember-intl/services/intl';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface IUnmanagedSubmit {
  demandHorizon?: number;
  isProtected: boolean;
}

interface IArgs extends IUnmanagedSubmit {
  lt?: number;
  disabled: boolean;
  onSubmit?: (isProtected: boolean) => void;
}
export default class UnmanagedSettingsEditor extends Component<IArgs> {
  // Services
  // ~~~~~

  @service declare intl: IntlService;

  // Properties
  // ~~~~~

  @tracked temp: IUnmanagedSubmit = {
    isProtected: this.args.isProtected
  };

  // Actions
  // ~~~~~

  @action
  updateIsProtected(isProtected: boolean) {
    this.temp = { ...this.temp, isProtected };
    return this.onSubmit();
  }

  @action
  onSubmit() {
    return this.args.onSubmit?.(this.temp.isProtected);
  }
}
